import { render, staticRenderFns } from "./ThermometerDQ.vue?vue&type=template&id=85d50212&scoped=true"
import script from "./ThermometerDQ.vue?vue&type=script&lang=js"
export * from "./ThermometerDQ.vue?vue&type=script&lang=js"
import style0 from "./ThermometerDQ.vue?vue&type=style&index=0&id=85d50212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d50212",
  null
  
)

export default component.exports